export enum EnvironmentType {
  Local = 'local',
  Development = 'development',
  Staging = 'staging',
  Production = 'production',
}
